export default __webpack_public_path__ + "static/4-d7fd163a2c5ec4aa5537a35f0f2482b5.jpg";